export function hideFromWappalyzer() {
  const wnd = window as any;

  (wnd.kendo || {}).version = '';
  wnd._ = null;
  wnd.moment = null;
  wnd.Hammer.VERSION = '';
  document.getElementsByTagName('app-root')[0].setAttribute('ng-version', '');
}
